import type { ReactNode } from "react";

import { Box, Card, Group, Skeleton, Stack, Text, Title } from "@mantine/core";

import cardContentStyles from "./cardContent.module.css";
import styles from "./metricCard.module.css";

interface Props {
    title: string;
    art: ReactNode;
    value: ReactNode;
    footer: ReactNode;
    isLoading: boolean;
    isEmpty: boolean;
    emptyValue: ReactNode;
    status?: string;
    delta?: string;
}

export function MetricCard({ title, art, value, footer, isLoading, isEmpty, emptyValue, status, delta }: Props) {
    let content: ReactNode;
    if (isLoading) {
        content = <Skeleton height={48} width={100} radius="sm" />;
    } else if (isEmpty) {
        content = <Text className={cardContentStyles.emptyState}>{emptyValue}</Text>;
    } else {
        content = value;
    }

    return (
        <Card classNames={{ root: styles.root }} radius="md" padding="lg">
            <Stack gap="md" h="100%" align="center">
                <Title order={3} className={styles.title}>
                    {title}
                </Title>
                <Group justify="center" className={styles.artWrap}>
                    {art}
                </Group>
                <Box className={styles.valueRow}>{content}</Box>
                <Text className={styles.footer} mt="auto">
                    Target: {footer}
                </Text>
                {status && (
                    <Text className={styles.status} ta="center">
                        {status}
                    </Text>
                )}
                {delta && (
                    <Text className={styles.delta} ta="center">
                        {delta}
                    </Text>
                )}
            </Stack>
        </Card>
    );
}
